/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GcpDiskSettings {
  /**
  * Disk name.
  */
  'name': string;
  /**
  * Disk type.
  */
  'type': string;
  /**
  * Size of the disk, in bytes.
  */
  'sizeBytes': number;
  /**
  * Provisioned IOPS for the disk. Applicable only when `type` is `pd-extreme`. When restoring, defaults to the original IOPS captured by the snapshot. 
  */
  'iops'?: number;
  /**
  * Disk throughput. When restoring, defaults to the original throughput captured by the snapshot. 
  */
  'throughput'?: number;
  /**
  * Disk description.
  */
  'description'?: string;
  /**
  * Labels to apply to the restored disk as key-value pairs, where key and value are both strings. These labels are always applied: `\"eon-restore\": \"true\"`, `\"eon-job-id\"`, `\"eon-original-disk-id\"`, `\"eon-original-disk-name\"`.  **Example:** `{\"primary\": \"true\"}` 
  */
  'labels'?: { [key: string]: string; };
  /**
  * ID of the customer-managed encryption key to use for the disk.
  */
  'encryptionKeyId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "type",
      "baseName": "type",
      "type": "string",
      "format": ""
    },
    {
      "name": "sizeBytes",
      "baseName": "sizeBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "iops",
      "baseName": "iops",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "throughput",
      "baseName": "throughput",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "description",
      "baseName": "description",
      "type": "string",
      "format": ""
    },
    {
      "name": "labels",
      "baseName": "labels",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "encryptionKeyId",
      "baseName": "encryptionKeyId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpDiskSettings.attributeTypeMap;
  }

  public constructor() {
  }
}

